/* eslint-disable no-empty-pattern */
import amapi from '@/api/amapi'
const initialState = () => ({
  remind2FA: { showed: true, remindAfter: 2000000000 },
})

const state = initialState

const getters = {
  remind2FA: state => state.remind2FA,
}

const mutations = {
  SET_REMIND_2FA (state, remind2FA = { showed: false, remindAfter: Date.now() }) {
    state.remind2FA = remind2FA
  },
}

const actions = {
  async getQRCode () {
    try {
      return amapi.makecall('mfa', { method: 'uri' })
    } catch (e) {
      throw e
    }
  },
  async activate2FA ({}, otp) {
    try {
      return amapi.makecall('mfa', { method: 'verify', otp })
    } catch (e) {
      throw e
    }
  },
  async deactivate2FA ({}, otp) {
    try {
      return amapi.makecall('mfa', { method: 'disable', otp })
    } catch (e) {
      throw e
    }
  },
  async recovery2FA ({}, data) {
    try {
      return amapi.makecall('mfa_recovery', data)
    } catch (e) {
      throw e
    }
  },
  async getSqList () {
    try {
      return amapi.makecall('profile_sq', { method: 'list' })
    } catch (e) {
      throw e
    }
  },
  async saveSqAnswers ({}, data) {
    try {
      return amapi.makecall('profile_sq', { method: 'update', ...data })
    } catch (e) {
      throw e
    }
  },
  async verifyPasswordStrength ({}, password) {
    try {
      return amapi.makecall('profile_passwordstrength', { password })
    } catch (e) {
      throw e
    }
  },
  async setProfilePassword ({}, passwords) {
    try {
      return amapi.makecall('profile_password', passwords)
    } catch (e) {
      throw e
    }
  },

  setRemind2FA ({ commit }, remind2FA) {
    localStorage.setItem('remind2FA', JSON.stringify(remind2FA))
    commit('SET_REMIND_2FA', remind2FA)
  },

  initRemind2FA ({ commit }) {
    let remind2FA = JSON.parse(localStorage.getItem('remind2FA'))
    if (!remind2FA) {
      remind2FA = { showed: false, remindAfter: Date.now() }
    }
    if (remind2FA.remindAfter < Date.now()) {
      remind2FA.showed = false
    }
    commit('SET_REMIND_2FA', remind2FA)
  },

  clearRemind2FA ({ getters }) {
    if (getters.remind2FA.showed && getters.remind2FA.remindAfter < Date.now()) {
      localStorage.removeItem('remind2FA')
    }
  },
}

const module = {
  state,
  getters,
  mutations,
  actions
}

export default module
